import { Routes } from '../routes';
import { MenuCodes } from '../../constants';

const pm = Routes.PAYMENT_METHODS;
const pi = Routes.PAYMENT_INTEGRATION;

export const items = [
  {
    [MenuCodes.HOME]: Routes.HOME,
    [MenuCodes.ACTIVATE_ACCOUNT]: Routes.ACTIVATE_ACCOUNT,
    [MenuCodes.TRANSACTIONS_AFFILIATIONS]: Routes.TRANSACTIONS_AFFILIATIONS,
  },
  {
    [MenuCodes.SIDEBAR_COBRAR]: {
      [MenuCodes.ONE_TIME_PAYMENT_LINK]: Routes.ONE_TIME_PAYMENT_LINK,
      [MenuCodes.RECURRING_PAYMENT_LINK]: Routes.RECURRING_PAYMENT_LINK,
      [MenuCodes.OPEN_PAYMENT_LINK]: Routes.OPEN_PAYMENT_LINK,
      [MenuCodes.QR_PAYMENT]: Routes.QR_PAYMENT,
      // TODO: Pago inteligente aún no existe.
      // [MenuCodes.SMART_PAYMENT]: Routes.SMART_PAYMENT,
      [MenuCodes.SUBSCRIPTIONS]: Routes.SUBSCRIPTIONS,
      [MenuCodes.PAYMENT_BUTTON]: Routes.PAYMENT_BUTTON,
    },
  },
  {
    [MenuCodes.SIDEBAR_PAGAR]: {
      [MenuCodes.PAYOUTS]: Routes.PAYOUTS,
      [MenuCodes.PAYOUT_CONTACTS]: Routes.PAYOUT_CONTACTS,
      [MenuCodes.PAY_FUND_TRANSFER]: Routes.PAY,
      [MenuCodes.PAY_FUND_CRYPTO]: Routes.PAY,
    },
  },
  {
    [MenuCodes.SIDEBAR_MOVIMIENTOS]: {
      [MenuCodes.TRANSACTIONS]: Routes.TRANSACTIONS,
      [MenuCodes.REFUNDS]: Routes.REFUNDS,
      [MenuCodes.CHARGEBACKS]: Routes.CHARGEBACKS,
      [MenuCodes.SETTLEMENTS]: Routes.SETTLEMENTS,
      [MenuCodes.REPORTS]: Routes.REPORTS,
    },
  },
  {
    [MenuCodes.SIDEBAR_CONEXIONES]: {
      [MenuCodes.PAYMENT_INTEGRATION]: pi,
      [MenuCodes.PAYMENT_INTEGRATION_API]: `${pi}?details=API`,
      [MenuCodes.SPLIT_PAYMENTS]: Routes.SPLIT_PAYMENTS,
    },
  },
  {
    [MenuCodes.SIDEBAR_RENTABILIDAD]: {
      [MenuCodes.PAYMENT_METHODS]: `${pm}?tab=payment-methods`,
      [MenuCodes.RENTABILITY_PAYOUTS]: `${pm}?tab=payouts`,
      [MenuCodes.RENTABILITY_COVERAGE]: `${pm}?tab=coverage`,
      [MenuCodes.RENTABILITY_CALCULATOR]: `${pm}?tab=calculator`,
      [MenuCodes.RENTABILITY_ACCREDITATION_TIMES]: `${pm}?tab=accreditation-times`,
      [MenuCodes.RENTABILITY_INSTALLMENTS]: `${pm}?tab=installments`,
      [MenuCodes.RENTABILITY_THREE_D_SECURE]: `${pm}?tab=threed-secure`,
    },
  },
  {
    [MenuCodes.SIDEBAR_MARKETING]: {
      [MenuCodes.CHECKOUT_THEMES]: Routes.CHECKOUT_THEMES,
      [MenuCodes.MARKETING_CAMPAIGNS]: Routes.MARKETING_CAMPAIGNS,
      [MenuCodes.CLIENTS]: Routes.CLIENTS,
    },
  },
  {
    [MenuCodes.SIDEBAR_CONFIGURATION]: {
      [MenuCodes.BANK_ACCOUNTS]: Routes.BANK_ACCOUNTS,
      [MenuCodes.COMPANY_INFORMATION]: Routes.COMPANY_INFORMATION,
      [MenuCodes.USER_MANAGEMENT]: Routes.USER_MANAGEMENT,
    },
  },
  {
    [MenuCodes.SIDEBAR_PROFILE]: Routes.PROFILE,
  },
];

export const getMenuSelected = (key: string) => {
  switch (key) {
    case MenuCodes.MOVEMENTS:
      return MenuCodes.SIDEBAR_MOVIMIENTOS;
    case MenuCodes.CHARGES:
      return MenuCodes.SIDEBAR_COBRAR;
    case MenuCodes.CONNECTIONS:
      return MenuCodes.SIDEBAR_CONEXIONES;
    case MenuCodes.PAY:
      return MenuCodes.SIDEBAR_PAGAR;
    case MenuCodes.RENTABILITY:
      return MenuCodes.SIDEBAR_RENTABILIDAD;
    case MenuCodes.TRANSACTION_DETAIL:
    case MenuCodes.TRANSACTIONS_STATEMENT:
      return MenuCodes.TRANSACTIONS;
    case MenuCodes.REFUND_DETAIL:
      return MenuCodes.REFUNDS;
    case MenuCodes.CREATED_PAYMENT_LINKS:
    case MenuCodes.CREATE_ONE_TIME_PAYMENT_LINK:
    case MenuCodes.PAYMENT_LINK:
      return MenuCodes.ONE_TIME_PAYMENT_LINK;
    case MenuCodes.CREATE_RECURRING_PAYMENT_LINK:
      return MenuCodes.RECURRING_PAYMENT_LINK;
    case MenuCodes.CLIENT_DETAIL:
      return MenuCodes.CLIENTS;
    case MenuCodes.PAYOUT_CONTACT_DETAIL:
    case MenuCodes.PAYOUT_CONTACT_CREATE:
    case MenuCodes.PAYOUT_CONTACT_BANK_ACCOUNT_CREATE:
    case MenuCodes.PAYOUT_CONTACT_BANK_ACCOUNT_EDIT:
      return MenuCodes.PAYOUT_CONTACTS;
    case MenuCodes.MARKETING:
      return MenuCodes.MARKETING_CAMPAIGNS;
    case MenuCodes.MARKETING_HUB:
      return MenuCodes.SIDEBAR_MARKETING;
    case MenuCodes.SUBSCRIPTIONS_DETAIL:
    case MenuCodes.SUBSCRIPTIONS_PLANS_DETAILS:
    case MenuCodes.SUBSCRIPTIONS_PLANS_CREATE:
    case MenuCodes.SUBSCRIPTIONS_PLANS_EDIT:
    case MenuCodes.SUBSCRIPTIONS_PLANS:
      return MenuCodes.SUBSCRIPTIONS;
    case MenuCodes.REVIEW_DOCUMENTATION:
      return MenuCodes.COMPANY_INFORMATION;
    case MenuCodes.PAYOUTS_STEP_ACCOUNT_DATA:
    case MenuCodes.PAYOUTS_STEP_PAYOUT_DATA:
    case MenuCodes.PAYOUTS_STEP_REVIEW:
      return MenuCodes.PAYOUTS;
    case MenuCodes.SPLIT_PAYMENTS_RESUME:
    case MenuCodes.SPLIT_PAYMENTS_STEP_USER_TYPE:
    case MenuCodes.SPLIT_PAYMENTS_STEP_INFORMATION:
    case MenuCodes.SPLIT_PAYMENTS_STEP_RESUME:
      return MenuCodes.SPLIT_PAYMENTS;
    case MenuCodes.PROFILE_PERSONAL_INFO:
    case MenuCodes.PROFILE_SECURITY:
      return MenuCodes.SIDEBAR_PROFILE;
    default:
      return key;
  }
};
